
export const userTypeOptions: Array<{
  label: string,
  value: string
}> = [
    {
      label: 'ADMINISTRADOR',
      value: 'ADMIN'
    },
    {
      label: 'VENDEDOR',
      value: 'SELLER'
    },
    {
      label: 'OPERADOR',
      value: 'OPERATOR'
    },
    {
      label: 'EXPERIÊNCIA DO CLIENTE',
      value: 'CUSTOMER EXPERIENCE'
    },
    {
      label: 'SUPERVISOR DE VENDAS',
      value: 'SALES SUPERVISOR'
    }
  ]